module.exports = __webpack_public_path__ + "img/canon.29fbe8c8.svg";